module.exports = __webpack_public_path__ + "img/map-step_4.7b3a13e.webp";